module.exports = __webpack_public_path__ + "img/locked_pricing.e73227e4.png";